module.exports = __webpack_public_path__ + "static/media/43-fence-beach.1b8ee268.jpg";